import {
  Box,
  Grid,
  Stack,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  styled,
} from "@mui/material";
import React from 'react'
import styles from "./invoice.module.scss"
import { tableCellClasses } from "@mui/material/TableCell";
import { ERCButton } from "components/button";
import { useSelector } from "react-redux";
import { showModal } from "store/reducers/modal";
import { useDispatch } from "react-redux";

const Invoice = () => {
  

  const currentTime = new Date().toLocaleTimeString('en-US', { timeZone: 'Africa/Lagos' });
  const back = () => {
    window.history.back()
  }

  const cartDetails = useSelector((state) => state.cart.items)
    console.log(cartDetails)
    const totalCartPrice = cartDetails.reduce((acc, cartDetail) => {
      return acc + (cartDetail?.quantity * cartDetail?.discountedPrice);
    }, 0);    
    
    const userDetail = useSelector((state) => state?.user?.data?.user?.data?.details);
    console.log("userDetail", userDetail)

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
    },
  }));


  return (
    <>
      <Box className={styles.invoice_container} style={{position: 'absolute',}}>
        <div id={"invoice-body"} style={{ backgroundColor: "white"}} >
          <Grid container mx={{ xs: 0, md: "auto"}} mb={5} width={{ xs: "100%", md: "80%" }}>
            <Grid mb={{ xs: 3, mb: 1 }} width={"100%"} item>
              <Stack
                px={1}
                spacing={2}
                direction={{ xs: "column", md: "row" }}
                justifyContent={"space-between"}
                alignItems={"center"}
                flex
                flexWrap="wrap"
                width={"100%"}
              >
                <Box bgcolor={""} width={200}>
                  <img
                    src={
                      "https://res.cloudinary.com/dmrtylvtc/image/upload/v1707135202/laags_wo0rrr.png"
                    }
                    alt="Lagos State"
                  />
                </Box>
                <Box bgcolor={""}>
                  <Typography
                    textAlign={"center"}
                    fontWeight={"bolder"}
                    variant="h5"
                  >
                    LAGOS STATE GOVERNMENT
                  </Typography>
                  <Typography
                    textAlign={"center"}
                    fontWeight={"bolder"}
                    variant="h6"
                  >
                    Central Billing System
                  </Typography>
                  <Typography textAlign={"center"} variant="body1">
                    Lagos State Education Resource Center
                  </Typography>
                  <Typography
                    textAlign={"center"}
                    fontWeight={"bolder"}
                    variant="body1"
                  >
                    Bill / Demand Notice / Payment Advice
                  </Typography>
                </Box>
                <Box bgcolor={""} border={2} p={2}>
                  <Typography variant="body1" fontWeight={"bolder"}>
                    Lagos State CBS
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid mb={{ xs: 3, mb: 1 }} xs={12} spacing={2} item>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={2}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Invoice Issued On:
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={5}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1">
                    LSEB-CBS Integrated Payment Platform
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={2}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Date Printed:
                  </Typography>
                </Grid>

                <Grid item xs={12} md={3} border={2} p={1}>
                  <Typography variant="body1">
                   {currentTime}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid xs={12} item>
              <Box>
                <Table sx={{ marginBottom: "0" }}>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}}>Bill Number</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "7px", md: "13px"}}}>Customer ID</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}}>Invoice Date</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableRow>
                    <StyledTableCell sx={{fontSize: {xs: "12px", md: "15px"}}}>69087656543231</StyledTableCell>
                    <StyledTableCell sx={{fontSize: {xs: "12px", md: "15px"}}}>566848</StyledTableCell>
                    <StyledTableCell sx={{fontSize: {xs:"12px", md:"15px"}}}> {currentTime}</StyledTableCell>
                  </TableRow>
                </Table>
              </Box>

              <Grid mt={2} container>
                <Grid
                  item
                  xs={12}
                  md={3}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Payer ID:
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={3}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1">N-8530954</Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={3}
                  border={2}
                  borderRight={{ xs: 2, md: 0 }}
                  borderBottom={{ xs: 0, md: 2 }}
                  p={1}
                >
                  <Typography variant="body1" fontWeight={"bold"}>
                    Status:
                  </Typography>
                </Grid>

                <Grid item xs={12} md={3} border={2} p={1}>
                  <Typography variant="body1">Unpaid</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid mt={2} xs={12} item>
              <Grid container>
                <Grid
                  item
                  border={2}
                  borderBottom={0}
                  borderRight={{ xs: 2, md: 0 }}
                  xs={12}
                  md={3}
                >
                  <Typography p={1} variant="body1" fontWeight={"bold"}>
                    Customer Name:
                  </Typography>
                </Grid>
                <Grid item border={2} borderBottom={0} xs={12} md={9}>
                  <Typography p={1} variant="body1">
                  {userDetail?.fullName}
                  </Typography>
                </Grid>
                <Grid
                  item
                  border={2}
                  borderBottom={{ xs: 0, md: 2 }}
                  borderRight={{ xs: 2, md: 0 }}
                  xs={12}
                  md={3}
                >
                  <Typography p={1} variant="body1" fontWeight={"bold"}>
                    Customer Email:
                  </Typography>
                </Grid>
                <Grid item border={2} xs={12} md={9}>
                  <Typography p={1} variant="body1">
                   {userDetail?.email}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid xs={12} item>
              <Box >
                <Table >
                  <TableHead>
                    <TableRow >
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}} >Item</StyledTableCell>
                      <StyledTableCell   
                      sx={{fontSize: {xs: "9px", md: "13px"}}}>Description</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md: "13px"}}}>Units</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs:"9px", md: "13px"}}}>Rate(&#8358;)</StyledTableCell>
                      <StyledTableCell sx={{fontSize: {xs: "9px", md:"13px"},}}>Amount(&#8358;)</StyledTableCell>
                    </TableRow>
                  </TableHead>
                   <>
  {cartDetails.map((cartDetail, index) => (
    <TableRow key={index}>
      <StyledTableCell sx={{ fontSize: { xs: "12px", md: "15px" } }}>
        {cartDetail?.quantity}
      </StyledTableCell>
      <StyledTableCell sx={{ fontSize: { xs: "12px", md: "15px" } }}>
        {cartDetail?.name}
      </StyledTableCell>
      <StyledTableCell sx={{ fontSize: { xs: "12px", md: "15px" } }}>
        {cartDetail?.quantity}
      </StyledTableCell>
      <StyledTableCell sx={{ fontSize: { xs: "12px", md: "15px" } }}>
        {cartDetail?.discountedPrice}
      </StyledTableCell>
      <StyledTableCell sx={{ fontSize: { xs: "12px", md: "15px" } }}>
        N{(cartDetail?.quantity * cartDetail?.discountedPrice).toLocaleString()}
      </StyledTableCell>
    </TableRow>
  ))}
</>

                </Table>
              </Box>

              <Stack direction={"row"}>
                <Box width={"70%"} p={1} border={2} textAlign={"right"}>
                  <Typography variant="body1" fontWeight={"bold"}>
                    Total Amount:{" "}
                  </Typography>
                </Box>
                <Box width={"30%"} p={1} border={2} textAlign={"center"}>
                  <Typography variant="body1" sx={{ marginRight: { xs: "0px", md: "100px" } }}>
                    {" "}
                    ₦{totalCartPrice}{" "}
                  </Typography>
                </Box>
              </Stack>

              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
                mt={3}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                  Amount in Words:{" "}
                  Twelve Thousands Naira
                  only
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1}>
                <Typography textAlign={"center"} variant={"subtitle1"} >
                  The official Lagos state bill will be collected by the bank
                  you make payment to.
                </Typography>
              </Stack>

              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                  Make Payment using your Bill Number: 69087656543231
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1}>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Total payment due immediately to Lagos State Government.
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Part payments are allowed: Subject to confirmation from Lagos
                  State Examinations Board.
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  [Part Payments may attract multiple transaction charges]
                </Typography>
              </Stack>

              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
                mt={3}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                  Service charges may be included at the point of payment
                </Typography>
              </Stack>
            </Grid>

            <Grid xs={12} mt={3} item>
              <Grid item>
                <Grid container>
                  <Grid item xs={7} border={2} borderRight={0} borderBottom={0}>
                    <Typography textAlign={"center"} variant="body1">
                      How to Pay
                    </Typography>
                  </Grid>
                  <Grid item xs={5} border={2} borderBottom={0}>
                    <Typography textAlign={"center"} variant="body1">
                      Payment Platform
                    </Typography>
                  </Grid>

                  <Grid
                    p={1}
                    item
                    xs={7}
                    border={2}
                    borderRight={0}
                    borderBottom={0}
                  >
                    <Typography variant="body1">Online Payment</Typography>
                    <Typography variant="body1">
                      1. Visit your preferred Online Payment Platform
                    </Typography>
                    <Typography variant="body1">
                      2. Enter your Bill Number & pay with your ATM card
                    </Typography>
                    <Typography variant="body1">
                      3. Note the Payment Reference/Receipt Number received
                    </Typography>
                  </Grid>
                  <Grid p={1} item xs={5} border={2} borderBottom={0}>
                    <Typography variant="body1">Web</Typography>
                  </Grid>

                  <Grid
                    p={1}
                    item
                    xs={7}
                    border={2}
                    borderRight={0}
                    borderBottom={0}
                  >
                    <Typography variant="body1">Bank Branch</Typography>
                    <Typography variant="body1">
                      1. Make payment at the bank teller
                    </Typography>
                    <Typography variant="body1">
                      2. Receive payment slip/confirmation from the teller
                    </Typography>
                    <Typography variant="body1">
                      3. Check the Lagos state portal for payment confirmation
                    </Typography>
                  </Grid>
                  <Grid p={1} item xs={5} border={2} borderBottom={0}>
                    <Typography variant="body1">Bank Branch</Typography>
                  </Grid>

                  <Grid p={1} item xs={7} border={2} borderRight={0}>
                    <Typography variant="body1">Mobile Payment</Typography>
                    <Typography variant="body1">
                      1. Make payment on your Mobile App using your Bill Number
                    </Typography>
                    <Typography variant="body1">
                      2. Note the Payment Reference/Receipt Number.
                    </Typography>
                  </Grid>
                  <Grid p={1} item xs={5} border={2}>
                    <Typography variant="body1">Mobile</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid xs={12} item>
              <Stack
                justifyContent={"center"}
                bgcolor={"black"}
                color={"white"}
                p={1}
              >
                <Typography textAlign={"center"} variant={"subtitle1"} sx={{fontSize: {xs: "12px", md: "13px"}}}>
                  Please visit https://office.lagosstate.gov.ng/receipt to
                  download your Payment Confirmation & Receipt. Visit the Lagos
                  State Examinations Board Online Portal to print your Payment
                  Confirmation & Receipt. Please ensure you present this Bill.
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1}>
                <Typography
                  textAlign={"center"}
                  fontWeight={"bolder"}
                  variant={"subtitle1"}
                >
                  Contact Details
                </Typography>
              </Stack>

              <Stack justifyContent={"center"} p={1} border={2}>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  If you have any questions about the Bill, please contact:
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Lagos State Examinations Board, Lagos State Secretariat,
                  Alausa, Ikeja, Lagos State
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Email: singlebilling@lagosstate.gov.ng
                </Typography>
                <Typography textAlign={"center"} variant={"subtitle1"}>
                  Help Desk Number: 01-2956737, 07045983303, 09090001175
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "50px",
            marginBottom: "1rem",
          }}
        >
          <div>
            <ERCButton onClick={back}> Back</ERCButton>
          </div>
          {/* <div>
            <ERCButton > Download Invoice</ERCButton>
          </div> */}
          <div>
            <ERCButton>Proceed To Payment</ERCButton>
          </div>
        </div>
      </Box>
    </>
  )
}

export default Invoice
